const MESSAGE_FILTERS = [
  { key: 'all', label: 'All', count: 5 },
  { key: 'requesters', label: 'Requesters', count: 2 },
  { key: 'internal', label: 'Internal', count: 3 }
];

const clone = (value) => JSON.parse(JSON.stringify(value));

const OWNER_MESSAGES_STATE = {
      active_filter: 'all',
      channel: 'sms',
      filters: MESSAGE_FILTERS,
      threads: [
        {
          id: 'thread-joseph',
          filter_key: 'requesters',
          initials: 'JM',
          initials_class: 'bg-success',
          name: 'Joseph Mokwena',
          preview: 'Inspector arriving 10:30, I\'ll meet them at reception.',
          tag: 'SMS',
          tag_class: 'bg-primary-subtle text-primary-emphasis',
          case_code: 'C-2026-0142',
          case_meta: '+27 82',
          activity: '2q',
          active: true
        },
        {
          id: 'thread-pulane',
          filter_key: 'internal',
          initials: 'PM',
          initials_class: 'bg-purple text-white',
          name: 'Pulane Maboe - coordinator',
          preview: '@sundeep - let me know the inspector final time.',
          tag: 'INTERNAL',
          tag_class: 'bg-light text-secondary border',
          case_code: 'C-2026-0137',
          case_meta: '3q',
          activity: ''
        },
        {
          id: 'thread-sibongile',
          filter_key: 'requesters',
          initials: 'SN',
          initials_class: 'bg-dark-purple text-white',
          name: 'Sibongile Ndlovu',
          preview: 'Thank you for the update. I will bring the supporting papers.',
          tag: 'WHATSAPP',
          tag_class: 'bg-success-subtle text-success-emphasis',
          case_code: 'C-2026-0139',
          case_meta: 'Yesterday',
          activity: ''
        },
        {
          id: 'thread-marlene',
          filter_key: 'internal',
          initials: 'MV',
          initials_class: 'bg-warning text-white',
          name: 'Marlene van Wyk - field officer',
          preview: 'Booked the meter visit for Thursday afternoon.',
          tag: 'INTERNAL',
          tag_class: 'bg-light text-secondary border',
          case_code: 'C-2026-0151',
          case_meta: 'Yesterday',
          activity: ''
        },
        {
          id: 'thread-thabang',
          filter_key: 'internal',
          initials: 'TM',
          initials_class: 'bg-success text-white',
          name: 'Thabang Mahlangu - panel',
          preview: 'Inspection report attached. Damage profile matches submission.',
          tag: 'INTERNAL',
          tag_class: 'bg-light text-secondary border',
          case_code: 'C-2026-0142',
          case_meta: '2 days',
          activity: ''
        }
      ],
      message_items: [
        {
          day_label: '10 MAY',
          messages: [
            {
              side: 'left',
              body: 'Hi, I want to claim for an accident on Saturday night. The car is at the workshop already.',
              meta: '10:30 - SMS - DELIVERED'
            },
            {
              side: 'right',
              body: 'Got it Joseph - claim opened as C-2026-0142. You\'ll get an SMS when each step completes. Please upload your repair quote when you have it.',
              meta: '10:32 - SMS - READ'
            }
          ]
        },
        {
          day_label: '11 MAY',
          messages: [
            {
              side: 'left',
              body: 'Quote and photos uploaded. SAPS reference is 8814/05/26.',
              meta: '09:14 - WHATSAPP - READ'
            }
          ]
        }
      ]
};

function create_owner_messages_state() {
  return clone(OWNER_MESSAGES_STATE);
}

export default {
  name: 'OwnerMessages',
  data: () => create_owner_messages_state(),
  computed: {
    active_thread_case_code() {
      const active_thread = this.threads.find((thread) => thread.active) || this.threads[0];
      return active_thread ? active_thread.case_code : 'C-2026-0142';
    },
    filtered_threads() {
      if (this.active_filter === 'all') {
        return this.threads;
      }

      return this.threads.filter((thread) => thread.filter_key === this.active_filter);
    }
  },
  methods: {
    set_filter(filter_key) {
      this.active_filter = filter_key;
    },
    set_channel(channel_key) {
      this.channel = channel_key;
    },
    go_to_case_detail(case_code) {
      this.$router.push({ name: 'ViewCaseDetails', params: { caseCode: case_code } });
    }
  }
};
